import api from "./api";

const notificationService = {
  /**
   * Get notifications for the logged-in user
   */
  getNotifications: async (options = {}) => {
    const payload = {
      page: options.page || 1,
      limit: options.limit || 20,
      is_read: options.is_read !== undefined ? options.is_read : null,
      type: options.type || null,
    };
    const response = await api.post("api/notifications/list", payload);
    return response.data;
  },

  /**
   * Get unread notification count
   */
  getUnreadCount: async () => {
    const response = await api.post("api/notifications/unread-count", {});
    return response.data;
  },

  /**
   * Mark notification as read
   */
  markAsRead: async (notificationId) => {
    const payload = {
      notification_id: notificationId,
    };
    const response = await api.post("api/notifications/mark-read", payload);
    return response.data;
  },

  /**
   * Mark all notifications as read
   */
  markAllAsRead: async () => {
    const response = await api.post("api/notifications/mark-all-read", {});
    return response.data;
  },

  /**
   * Delete a notification
   */
  deleteNotification: async (notificationId) => {
    const payload = {
      notification_id: notificationId,
    };
    const response = await api.post("api/notifications/delete", payload);
    return response.data;
  },
};

export default notificationService;
